<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card >
            <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
            <div v-else class="address">
                <b-form inline class="formBox"> 
                    <b-form-group class="inputGrp" :label="$t('defination.panel.brand')">
                        <b-form-select 
                            class="select"
                            v-model="selectedBrand"
                            text-field="name"
                            value-field="id"
                            :options="brands"
                            :select-size="25"
                        />
                        <div class="buttons">
                            <b-button variant="primary" :title="$t('general.add')" @click="openModal(true,'add', {type: 'brand'})" >
                                 <b-icon icon="file-earmark-plus-fill"></b-icon> 
                            </b-button>
                            <b-button variant="success" :title="$t('general.edit')" @click="openModal(true,'edit', brand)"> 
                                <b-icon icon="pen-fill"  ></b-icon> 
                            </b-button>
                            <b-button variant="danger" :title="$t('general.delete')" @click="openModal(true,'delete', brand)"> 
                                <b-icon icon="trash" ></b-icon> 
                            </b-button>
                        </div>
                    </b-form-group>
                    <b-form-group class="inputGrp" :label="$t('defination.panel.model')">
                        <b-form-select
                            class="select"
                            text-field="name"
                            value-field="id"
                            v-model="selectedModel"
                            :options="models"
                            :select-size="25"
                        />    
                        <div class="buttons">
                            <b-button variant="primary" :title="$t('general.add')" @click="openModal(true,'add',  {type: 'model', brand_id: selectedBrand})"> 
                                <b-icon icon="file-earmark-plus-fill"></b-icon> 
                            </b-button>
                            <b-button variant="success" :title="$t('general.edit')" @click="openModal(true,'edit', model)"> 
                                <b-icon icon="pen-fill" ></b-icon> 
                            </b-button>
                            <b-button variant="danger" :title="$t('general.delete')"  @click="openModal(true,'delete', model)"> 
                                <b-icon icon="trash"></b-icon> 
                            </b-button>
                        </div>
                    </b-form-group>
                </b-form>
            </div>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import Modals from './modals/';


    let breadCrumb = [
        { label: i18n.t('pages.defination.name'), url: "/Defination" },
        { label: i18n.t('pages.defination.panel'), url: "/Defination/Panel" },
    ]
    export default {
        name: "Panel",
        created:function(){
            this.$store.dispatch('listBrands')
        },
        computed: {
            brands(){
                return this.$store.getters.getBrands
            },
            models(){
                return this.$store.getters.getModels
            },
            loading(){
                return this.$store.getters.getDefinationLoading
            }
        },
        watch: {
            selectedBrand(){
                this.$store.dispatch('listModels', this.selectedBrand)
                this.brand = this.brands.find(brand => brand.id === this.selectedBrand)
                this.brand.type = "brand"
            },
            selectedModel(){
                this.model = this.models.find(model => model.id === this.selectedModel)
                this.model.type = "model"
                this.model.brand_id = this.selectedBrand
            },
        },
        data: function(){
            return{
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"Panel",
                modalName: "",
                brand: {},
                selectedBrand: 0, 
                model: {}, 
                selectedModel: 0,          
            }
        },
        components:{
            BreadCrumb, Modals
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        }
    }
</script>

<style lang="css" scoped > 
    @import "./styles/address.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/Panel.vue